__turbopack_context__.v({
  "error": "PhoneInputField-module__DOw7mW__error",
  "fallback": "PhoneInputField-module__DOw7mW__fallback",
  "wrap": "PhoneInputField-module__DOw7mW__wrap",
});
